import { graphql } from "../../graphql";

export const ActiveSessionSub = graphql(`
	subscription UserSession($user: String!, $mobile: Boolean!) {
		session(
			where: { 
				folio_user: { _eq: $user }, 
				is_mobile: { _eq: $mobile }
			}
		) {
			id
			last_seen
			session_start
			is_mobile
			excel
		}
	}
`);

export const ActiveExcelSessionSub = graphql(`
	subscription UserExcelSession($user: String!) {
		session(
			where: { 
				folio_user: { _eq: $user }, 
				excel_session_id: { _is_null: false }
			}
		) {
			id
			last_seen
			session_start
			is_mobile
			excel
			excel_session_id
		}
	}
`);

export const StartSessionMut = graphql(`
  mutation StartSession(
    $user: String!
    $mobile: Boolean!
    $session_id: String!
    $last_seen: timestamptz!
    $session_start: timestamptz!
  ) {
    insert_session_one(
      object: {
        folio_user: $user
        is_mobile: $mobile
        excel: false
        id: $session_id
        last_seen: $last_seen
        session_start: $session_start
      }
      on_conflict: { constraint: session_pkey, update_columns: [id, last_seen, session_start, excel] }
    ) {
      id
      last_seen
    }
    update_folio_user_by_pk(
      pk_columns: { id: $user }
      _set: { logout_requested_at: null }
    ) {
      id
    }
  }
`);

export const StartExcelSessionMut = graphql(`
  mutation StartExcelSession(
    $user: String!
    $last_seen: timestamptz!
    $session_start: timestamptz!
    $excel_session_id: String!
  ) {
    insert_session_one(
      object: {
        folio_user: $user
        is_mobile: false
        excel: true
        id: $excel_session_id
        last_seen: $last_seen
        session_start: $session_start
        excel_session_id: $excel_session_id
      }
      on_conflict: { constraint: session_pkey, update_columns: [last_seen, session_start, excel, excel_session_id] }
    ) {
      id
      last_seen
      excel_session_id
    }
    update_folio_user_by_pk(
      pk_columns: { id: $user }
      _set: { logout_requested_at: null }
    ) {
      id
    }
  }
`);

export const LivenessProbeMutation = graphql(`
  mutation LivenessProbeMutation($user: String!, $mobile: Boolean!) {
    update_session_by_pk(pk_columns: { folio_user: $user, is_mobile: $mobile }, _set: { last_seen: "now()", excel: false }) {
      id
    }
		update_folio_user_by_pk(pk_columns: { id: $user }, _set: { last_seen: "now()" }) {
      id
    }
  }
`);

export const ExcelLivenessProbeMutation = graphql(`
  mutation ExcelLivenessProbeMutation($user: String!) {
    update_session_by_pk(pk_columns: { folio_user: $user, is_mobile: false }, _set: { last_seen: "now()", excel: true }) {
      id
    }
		update_folio_user_by_pk(pk_columns: { id: $user }, _set: { last_seen: "now()" }) {
      id
    }
  }
`);

export const DeleteSession = graphql(`
	mutation DeleteSession($user: String!, $mobile: Boolean!) {
		update_folio_user_by_pk(pk_columns: { id: $user }, _set: { logout_requested_at: "now()", last_seen: "now()" }) {
			id
		}
		delete_session(where: { folio_user: { _eq: $user }, is_mobile: { _eq: $mobile } }) {
			affected_rows
		}
	}
`);

export const ClearExcelSessionMut = graphql(`
	mutation ClearExcelSession($user: String!) {
		update_session_by_pk(
			pk_columns: { folio_user: $user, is_mobile: false }
			_set: { excel_session_id: null, excel: false }
		) {
			id
			excel_session_id
			excel
		}
		update_folio_user_by_pk(pk_columns: { id: $user }, _set: { logout_requested_at: "now()" }) {
			id
		}
	}
`);
